// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-toggle[data-v-23f4be2a]::after{content:none !important}.show-menu[data-v-23f4be2a]{display:inherit !important}", ""]);
// Exports
module.exports = exports;
